<ul class="items-list item-size row">
  @if (viewModel.primaryButton) {
    <li class="col-12">
      @if (viewModel.primaryButton.link | link: ParamsUtils.cidMap(viewModel.cid) | async; as hrefLink) {
        <a class="items-list-item dashboard-item-pos" (click)="doClickPrimaryButtonLink(); (false)" [href]="hrefLink">
          <div class="item-container">
            <div class="item-text">
              <span>
                <strong>{{ 'dashboard.billOld' | translate }}</strong>
              </span>
            </div>
          </div>
        </a>
      }
    </li>
  }
  @if (viewModel.secondaryButton && viewModel.isInQuarantine) {
    <li class="col-12">
      @if (viewModel.secondaryButton.link | link: ParamsUtils.cidMap(viewModel.cid) | async; as hrefLink) {
        <a
          class="items-list-item dashboard-item-pos pt-1"
          (click)="doClickSecondaryButtonLink(); (false)"
          [href]="hrefLink"
          [ecmDisabledAction]="isDisabledEclair"
        >
          <div class="item-container">
            <div class="item-text">
              <span>
                <strong> {{ viewModel.secondaryButton.label }}</strong>
              </span>
              <small class="item-desc">
                {{ 'dashboard.forbidden.terminatedContract.textRio' | translate }} <br />
                {{ 'dashboard.forbidden.terminatedContract.textRioDetails' | translate }}
              </small>
            </div>
          </div>
        </a>
      }
    </li>
  }
</ul>
